<template>
  <div class="form-group custom-control custom-checkbox"
    v-bind:class="{'has-error': errors.has(field.key)}">
    <label class="form-item-group form-item-checkbox">
      <input type="checkbox"
        class="custom-control-input"
        v-on:change="$emit('input', $event.target.checked)"
        v-bind:name="field.key"
        v-bind:checked="value"
        v-validate="validationRules"
        v-bind:data-vv-as="strippedFieldTitle"
        tabindex="1">
      <span class="custom-control-label" v-html="sanitizedFieldTitle"></span>
    </label>
    <small class="form-help-text" v-html="sanitizedHelpText"></small>
    <span class="invalid-feedback"
      v-if="errors.has(field.key)">
      {{ errors.first(field.key) }}
    </span>
  </div>
</template>

<script>
import InputMixin from '@/mixins/InputMixin';

/**
 * Input Boolean
 * -- Implements v-model
 *
 * A field that renders a checkbox for true/false values.
 */
export default {
  name: 'InputBoolean',
  mixins: [
    InputMixin,
  ],
  props: {
    /**
     * The input value
     */
    value: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
};
</script>
